import TagAlertValue from '@/modules/core/models/TagAlertValue'
import TagLinkAlertValue from '@/modules/core/models/TagLinkAlertValue'

class MediatorContactAlertValue extends TagAlertValue {
  phoneText: string
  emailText: string

  constructor(data: any) {
    super(data)
    this.phoneText = data.phoneText
    this.emailText = data.emailText
  }
}

export default class LifeConfigurationTags {
  capitalToInsuredAlert: TagAlertValue
  capitalToInsuredContactAlert: TagLinkAlertValue
  professionLowRiskAlert: TagAlertValue
  professionHighRiskAlert: TagAlertValue
  activityHighRiskAlert: TagAlertValue
  capitalToInsuredContactAlertMediator?: MediatorContactAlertValue
  professionHighRiskAlertMediator?: TagAlertValue
  activityHighRiskAlertMediator?: TagAlertValue
  capitalAlertAmountMediator?: string
  capitalAlertMediatorContactPhone?: string
  capitalAlertMediatorContactEmail?: string
  alertRiskProfessionMediator?: string
  alertRiskActivityMediator?: string
  holderAlert: TagAlertValue
  personalDataAlert: TagAlertValue
  contactDataAlert: TagAlertValue
  customDateAlert: TagAlertValue
  mortgageLoanAlert: TagAlertValue
  heirsPolicyBeneficiariesAlert: TagAlertValue
  myPolicyBeneficiariesAlert: TagAlertValue

  constructor(data: LifeConfigurationTags) {
    this.capitalToInsuredAlert = new TagAlertValue(data.capitalToInsuredAlert)
    this.capitalToInsuredContactAlert = new TagLinkAlertValue(data.capitalToInsuredContactAlert)
    this.professionLowRiskAlert = new TagAlertValue(data.professionLowRiskAlert)
    this.professionHighRiskAlert = new TagAlertValue(data.professionHighRiskAlert)
    this.activityHighRiskAlert = new TagAlertValue(data.activityHighRiskAlert)
    this.capitalToInsuredContactAlertMediator = data.capitalToInsuredContactAlertMediator
      ? new MediatorContactAlertValue(data.capitalToInsuredContactAlertMediator)
      : undefined
    this.professionHighRiskAlertMediator = data.professionHighRiskAlertMediator
      ? new TagAlertValue(data.professionHighRiskAlertMediator)
      : undefined
    this.activityHighRiskAlertMediator = data.activityHighRiskAlertMediator
      ? new TagAlertValue(data.activityHighRiskAlertMediator)
      : undefined
    this.capitalAlertAmountMediator = data.capitalAlertAmountMediator
    this.capitalAlertMediatorContactPhone = data.capitalAlertMediatorContactPhone
    this.capitalAlertMediatorContactEmail = data.capitalAlertMediatorContactEmail
    this.alertRiskProfessionMediator = data.alertRiskProfessionMediator
    this.alertRiskActivityMediator = data.alertRiskActivityMediator
    this.holderAlert = new TagAlertValue(data.holderAlert)
    this.personalDataAlert = new TagAlertValue(data.personalDataAlert)
    this.contactDataAlert = new TagAlertValue(data.contactDataAlert)
    this.customDateAlert = new TagAlertValue(data.customDateAlert)
    this.mortgageLoanAlert = new TagAlertValue(data.mortgageLoanAlert)
    this.heirsPolicyBeneficiariesAlert = new TagAlertValue(data.heirsPolicyBeneficiariesAlert)
    this.myPolicyBeneficiariesAlert = new TagAlertValue(data.myPolicyBeneficiariesAlert)
  }
}
